import { createApp } from "vue";
import App from "./App.vue";
import { pinia } from "./stores/pinia";
import { useUiStore } from "./stores/ui.store";
import router from "./router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./assets/styles/main.scss";
import api from "./services/api";
import useEventManager from "./composables/useEventManager";
import { currentTenant, CURRENT_TENANT_ID } from "./config/tenants";

// Tenant title ve favicon uygula
document.title = currentTenant.appTitle || "OwSuite";
const faviconLink = document.querySelector("link[rel~='icon']");
if (faviconLink && currentTenant.favicon) {
  faviconLink.href = currentTenant.favicon;
}

const app = createApp(App);

// Toast options
const toastOptions = {
  // FreqOpt/FleetOpt: alt sağ — header ve AI FAB ile çakışmasın
  position: "bottom-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
  containerClassName: "ow-toast-host",
};

// Global properties
app.config.globalProperties.$api = api;
app.config.globalProperties.$tenant = currentTenant;
app.config.globalProperties.$tenantId = CURRENT_TENANT_ID;

// Global composable
app.config.globalProperties.$eventManager = useEventManager();

// Pinia + router
app.use(pinia);
useUiStore(pinia).initTheme();
app.use(router);
app.use(Toast, toastOptions);

router.isReady().then(() => {
  app.mount("#app");
});
